import { z } from 'zod';
import { zLinklyConnectionStatus, zLinklyEnv } from '../enums';
import { iPadCvxWithoutTokenSchema } from '../iPads/iPadSchema';
import { categoryCvxSchema } from '../menu/categorySchema';
import { menuItemsByCategorySchema } from '../menu/menuItemSchema';
import { modifierGroupCvxSchema } from '../menu/modifierGroupSchema';
import { modifiersByModifiersGroupSchema } from '../menu/modifierSchema';
import { openStatusCvxCalcSchema } from '../openStatusSchema';
import { posConfigCvxSchema } from '../posConfig/posConfigSchema';
import { restaurantCvxSchema } from '../restaurant/restaurantSchema';

export const cvxDataResponseSchema = z.object({
  categories: z.array(categoryCvxSchema),
  menuItems: menuItemsByCategorySchema,
  modifierGroups: z.array(modifierGroupCvxSchema),
  modifiers: modifiersByModifiersGroupSchema,
  openStatus: openStatusCvxCalcSchema.nullable(),
  posConfig: posConfigCvxSchema.optional(),
  /** This restaurant's paired iPads (device-authed POS build only; empty on the Cognito path). */
  iPads: z.array(iPadCvxWithoutTokenSchema).optional(),
  /** `uuid` of the iPad making this request (device-authed POS build only). */
  currentPosTerminalUuid: z.string().nullable().optional(),
  restaurant: restaurantCvxSchema,
  registerLastClosedAt: z.number().nullable().default(null).optional(), // optional() for API backwards compatibility.
  /** Whether EFTPOS integration is enabled for this POS terminal */
  isLinklyDeviceEnabled: z.boolean().optional(), // optional() for API backwards compatibility.
  /** Connection status of the Linkly EFTPOS device */
  linklyConnectionStatus: zLinklyConnectionStatus.nullable().optional(), // optional() for API backwards compatibility.
  /** Whether Linkly credentials (username/password) have been set */
  hasLinklyCredentials: z.boolean().optional(), // optional() for API backwards compatibility.
  /** The Linkly username (if set) */
  linklyUsername: z.string().nullable().optional(), // optional() for API backwards compatibility.
  /** Which Linkly env this terminal's device routes to (emulator/sandbox/production), or null if no device. */
  linklyEnv: zLinklyEnv.nullable().optional(), // optional() for API backwards compatibility.
});
export type CvxDataResponse = z.output<typeof cvxDataResponseSchema>;
